import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment/moment'
import classNames from 'classnames'
import { momentToLocal } from 'helpers/schedule.js'
import { HAS_OFFSET } from '../../constants'
import styles from './TimeLine.scss'

const TimeLine = props => {
    const { scaleLengthHour, scaleStartHour, now } = props
    const timeLinePosition = calcPercentage(scaleStartHour, scaleLengthHour, now) + '%'
    const timeString = momentToLocal(now).format('LT')
    const containerClassNames = classNames(styles.timeLineContainer, {
        [styles.forOneBattleMode]: props.forOneBattleMode,
        [styles.forAllBattleModes]: props.forAllBattleModes,
    })
    const timeValueClassNames = classNames(
        styles.timeValue,
        {
            [styles.timeValue__with_offset]: HAS_OFFSET,
        }
    )

    return (
        <div className={containerClassNames}>
            <div className={styles.base} style={{ left: timeLinePosition }}>
                <span className={timeValueClassNames}>
                    {timeString}
                </span>
                <div className={styles.timeLine} />
                <div className={styles.headerHalo} />
                <div className={styles.footerHalo} />
            </div>
        </div>
    )
}

TimeLine.propTypes = {
    forOneBattleMode: PropTypes.bool,
    forAllBattleModes: PropTypes.bool,
    scaleLengthHour: PropTypes.number,
    scaleStartHour: PropTypes.number,
    now: PropTypes.instanceOf(moment),
}

export default TimeLine

export function calcPercentage(scaleStartHour, scaleLengthHour, now) {
    let startTime = moment(now).utc().hour(scaleStartHour).local().startOf('hour')
    if (startTime > now) startTime.subtract(1, 'days')
    const duration = moment.duration(scaleLengthHour, 'hours')
    const secondsPassed = now.diff(startTime, 'seconds')
    return secondsPassed * 100 / duration.asSeconds()
}



// WEBPACK FOOTER //
// ./containers/Schedule/components/TimeLine/TimeLine.jsx